import * as React from 'react';

const ListPost = (props) => {
	return (
		<div style={{
			position: 'absolute',
			width: 40,
			height: 40,
			left: -20,
			top: -30,
			cursor: 'pointer',
			background: `url(${props.img}) no-repeat center center/50%`,
		}}><a href="JavaScript:Void(0);"></a></div>
	);
};

export default ListPost;



// WEBPACK FOOTER //
// ./src/containers/component/ListStore.tsx